import { Center } from '@chakra-ui/react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import React, { forwardRef } from 'react'
import { srcSet as buildSrcSet } from '../../utils/img'

// react-lazy-load-image-component's FC type conflicts with React 19's ReactNode; use as component type
const LazyImg = LazyLoadImage as React.ComponentType<React.PropsWithChildren<Record<string, unknown>>>

export const LazyLoadedImage = (props: any) => {
  if (!props.src || props.src === '') return props.alt

  // Check if the image is a GIF to ensure it animates properly
  const isGif = props.src?.toLowerCase().endsWith('.gif') || props.src?.includes('.gif')

  // Use regular img tag for GIFs to ensure animation works properly
  if (isGif) {
    return (
      <Center
        w={props.w}
        h={props.h}
        overflowX="hidden"
        overflowY="hidden"
        onClick={props.onClick}
        position="relative"
        {...props}
      >
        <img
          src={props.src}
          alt={props.alt || ''}
          style={{
            objectFit: 'cover',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minHeight: '100%',
            minWidth: '100%',
            height: '100%',
            width: '100%',
          }}
          loading="eager"
          decoding="async"
        />
      </Center>
    )
  }

  return (
    <Center
      w={props.w}
      h={props.h}
      overflowX="hidden"
      overflowY="hidden"
      onClick={props.onClick}
      position="relative"
      {...props}
    >
      <LazyImg
        effect="opacity"
        height="100%"
        width="100%"
        src={props.src}
        srcSet={buildSrcSet(props.src)}
        sizes="(max-width: 600px) 400px, 800px"
        style={{
          objectFit: 'cover',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '100%',
          minWidth: '100%',
        }}
      />
    </Center>
  )
}

export const LazyLoadedImageNoCenter = forwardRef((props: any, ref: React.Ref<HTMLDivElement>) => {
  if (!props.src || props.src === '') return props.alt

  // Check if the image is a GIF to ensure it animates properly
  const isGif = props.src?.toLowerCase().endsWith('.gif') || props.src?.includes('.gif')

  // Use regular img tag for GIFs to ensure animation works properly
  if (isGif) {
    return (
      <Center
        ref={ref}
        w={props.w}
        h={props.h}
        overflowX="hidden"
        overflowY="hidden"
        onClick={props.onClick}
        position="relative"
        {...props}
      >
        <img
          src={props.src}
          alt={props.alt || ''}
          style={{
            objectFit: 'cover',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '100%',
            height: '100%',
            width: '100%',
          }}
          loading="eager"
          decoding="async"
        />
      </Center>
    )
  }

  return (
    <Center
      ref={ref}
      w={props.w}
      h={props.h}
      overflowX="hidden"
      overflowY="hidden"
      onClick={props.onClick}
      position="relative"
      {...props}
    >
      <LazyImg
        effect="opacity"
        height="100%"
        width="100%"
        src={props.src}
        srcSet={buildSrcSet(props.src)}
        sizes="(max-width: 600px) 400px, 800px"
        style={{
          objectFit: 'cover',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '100%',
        }}
      />
    </Center>
  )
})
